import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";

class ContactService {
  DoGetContactByContactIdList(contactIdList: Array<number>) {
    const _input = {
      merchantId: MerchantId(),
      contactIdList: contactIdList,
      language: i18n.locale,
    };
    return service.peakExportAPI
      .post("/api/Contact/GetContactByContactIdList", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
}

export default new ContactService();
